import { render } from "./demo-day-auction-information.vue?vue&type=template&id=9b55f7fe"
import script from "./demo-day-auction-information.vue?vue&type=script&lang=js"
export * from "./demo-day-auction-information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__